export const messages = {
  en: {
    contractManage: {
      search: {
        title: 'Search Conditions',
        hide: 'Hide',
        more: 'More',
        search: 'Search',
        reset: 'Reset'
      },
      allTypes: 'All',
      list: {
        title: 'Contract Information'
      },
      contractNamePlaceholder: 'Please enter contract name',
      contractCodePlaceholder: 'Please enter contract number',
      contractTypePlaceholder: 'Please select contract type',
      partyBPlaceholder: 'Please enter party B',
      startTimePlaceholder: 'Please enter start time',
      endTimePlaceholder: 'Please enter end time',
      parentContractCodePlaceholder: 'Please enter parent contract number',
      fetchError: 'Failed to fetch contract data',
      table: {
        contractName: 'Contract Name',
        contractCode: 'Contract Number',
        parentContractCode: 'Parent Contract Number',
        contractType: 'Contract Type',
        operator: 'Operator',
        amount: 'Contract Amount',
        partyB: 'Party B',
        validityPeriod: 'Validity Period',
        createTime: 'Creation Time',
        status: 'Status',
        operation: 'Operation'
      },
      operation: {
        fee: 'Fee',
        view: 'View',
        print: 'Print',
        delete: 'Delete'
      },
      edit: {
        title: 'Edit Contract',
        contractName: 'Contract Name',
        contractNamePlaceholder: 'Required, please enter contract name',
        contractCode: 'Contract Number',
        contractCodePlaceholder: 'Required, please enter contract number',
        contractType: 'Contract Type',
        contractTypePlaceholder: 'Required, please select contract type',
        partyA: 'Party A',
        partyAPlaceholder: 'Required, please enter party A',
        aContacts: 'Party A Contact',
        aContactsPlaceholder: 'Required, please enter party A contact',
        aLink: 'Party A Contact Phone',
        aLinkPlaceholder: 'Required, please enter party A contact phone',
        partyB: 'Party B',
        partyBPlaceholder: 'Required, please enter party B',
        bContacts: 'Party B Contact',
        bContactsPlaceholder: 'Required, please enter party B contact',
        bLink: 'Party B Contact Phone',
        bLinkPlaceholder: 'Required, please enter party B contact phone',
        operator: 'Operator',
        operatorPlaceholder: 'Required, please enter operator',
        operatorLink: 'Contact Phone',
        operatorLinkPlaceholder: 'Required, please enter contact phone',
        amount: 'Contract Amount',
        amountPlaceholder: 'Optional, please enter contract amount',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please enter start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please enter end time',
        signingTime: 'Signing Time',
        signingTimePlaceholder: 'Required, please enter signing time',
        contractFiles: 'Contract Attachments',
        addFile: 'Add Attachment',
        fileIndex: 'No.{index}',
        deleteFile: 'Delete Attachment',
        cancel: 'Cancel',
        save: 'Save',
        saveSuccess: 'Contract saved successfully',
        saveError: 'Failed to save contract',
        fileTypeError: 'Only PNG, PDF, JPG files are allowed',
        uploadSuccess: 'File uploaded successfully',
        uploadError: 'Failed to upload file'
      },
      delete: {
        title: 'Confirm Operation',
        confirmMessage: 'Are you sure to delete this contract?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        success: 'Contract deleted successfully',
        error: 'Failed to delete contract'
      }
    }
  },
  zh: {
    contractManage: {
      search: {
        title: '查询条件',
        hide: '隐藏',
        more: '更多',
        search: '查询',
        reset: '重置'
      },
      allTypes: '全部',
      list: {
        title: '合同信息'
      },
      contractNamePlaceholder: '请输入合同名称',
      contractCodePlaceholder: '请输入合同编号',
      contractTypePlaceholder: '请选择合同类型',
      partyBPlaceholder: '请输入合同乙方',
      startTimePlaceholder: '请输入起草开始时间',
      endTimePlaceholder: '请输入起草结束时间',
      parentContractCodePlaceholder: '请输入父合同编号',
      fetchError: '获取合同数据失败',
      table: {
        contractName: '合同名称',
        contractCode: '合同编号',
        parentContractCode: '父合同编号',
        contractType: '合同类型',
        operator: '经办人',
        amount: '合同金额',
        partyB: '合同乙方',
        validityPeriod: '有效期',
        createTime: '起草时间',
        status: '状态',
        operation: '操作'
      },
      operation: {
        fee: '费用',
        view: '查看',
        print: '打印',
        delete: '删除'
      },
      edit: {
        title: '编辑合同',
        contractName: '合同名称',
        contractNamePlaceholder: '必填，请填写合同名称',
        contractCode: '合同编号',
        contractCodePlaceholder: '必填，请填写合同编号',
        contractType: '合同类型',
        contractTypePlaceholder: '必填，请选择合同类型',
        partyA: '甲方',
        partyAPlaceholder: '必填，请填写甲方',
        aContacts: '甲方联系人',
        aContactsPlaceholder: '必填，请填写甲方联系人',
        aLink: '甲方联系电话',
        aLinkPlaceholder: '必填，请填写甲方联系电话',
        partyB: '乙方',
        partyBPlaceholder: '必填，请填写乙方',
        bContacts: '乙方联系人',
        bContactsPlaceholder: '必填，请填写乙方联系人',
        bLink: '乙方联系电话',
        bLinkPlaceholder: '必填，请填写乙方联系电话',
        operator: '经办人',
        operatorPlaceholder: '必填，请填写经办人',
        operatorLink: '联系电话',
        operatorLinkPlaceholder: '必填，请填写联系电话',
        amount: '合同金额',
        amountPlaceholder: '选填，请填写合同金额',
        startTime: '开始时间',
        startTimePlaceholder: '必填，请填写开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        signingTime: '签订时间',
        signingTimePlaceholder: '必填，请填写签订时间',
        contractFiles: '合同附件',
        addFile: '添加附件',
        fileIndex: '第{index}个',
        deleteFile: '删除附件',
        cancel: '取消',
        save: '保存',
        saveSuccess: '合同保存成功',
        saveError: '合同保存失败',
        fileTypeError: '仅支持PNG、PDF、JPG格式文件',
        uploadSuccess: '文件上传成功',
        uploadError: '文件上传失败'
      },
delete: {
        title: '请确认您的操作',
        confirmMessage: '确定删除合同信息',
        cancel: '点错了',
        confirm: '确认删除',
        success: '合同删除成功',
        error: '合同删除失败'
      }
    }
  },
  'zh-TW': {
    contractManage: {
      search: {
        title: '查詢條件',
        hide: '隱藏',
        more: '更多',
        search: '查詢',
        reset: '重設'
      },
      allTypes: '全部',
      list: {
        title: '合同信息'
      },
      contractNamePlaceholder: '請輸入合同名稱',
      contractCodePlaceholder: '請輸入合同編號',
      contractTypePlaceholder: '請選擇合同類型',
      partyBPlaceholder: '請輸入合同乙方',
      startTimePlaceholder: '請輸入起草開始時間',
      endTimePlaceholder: '請輸入起草結束時間',
      parentContractCodePlaceholder: '請輸入父合同編號',
      fetchError: '獲取合同數據失敗',
      table: {
        contractName: '合同名稱',
        contractCode: '合同編號',
        parentContractCode: '父合同編號',
        contractType: '合同類型',
        operator: '經辦人',
        amount: '合同金額',
        partyB: '合同乙方',
        validityPeriod: '有效期',
        createTime: '起草時間',
        status: '狀態',
        operation: '操作'
      },
      operation: {
        fee: '費用',
        view: '查看',
        print: '列印',
        delete: '刪除'
      },
      edit: {
        title: '編輯合同',
        contractName: '合同名稱',
        contractNamePlaceholder: '必填，請填寫合同名稱',
        contractCode: '合同編號',
        contractCodePlaceholder: '必填，請填寫合同編號',
        contractType: '合同類型',
        contractTypePlaceholder: '必填，請選擇合同類型',
        partyA: '甲方',
        partyAPlaceholder: '必填，請填寫甲方',
        aContacts: '甲方聯絡人',
        aContactsPlaceholder: '必填，請填寫甲方聯絡人',
        aLink: '甲方聯繫電話',
        aLinkPlaceholder: '必填，請填寫甲方聯繫電話',
        partyB: '乙方',
        partyBPlaceholder: '必填，請填寫乙方',
        bContacts: '乙方聯絡人',
        bContactsPlaceholder: '必填，請填寫乙方聯絡人',
        bLink: '乙方聯繫電話',
        bLinkPlaceholder: '必填，請填寫乙方聯繫電話',
        operator: '經辦人',
        operatorPlaceholder: '必填，請填寫經辦人',
        operatorLink: '聯繫電話',
        operatorLinkPlaceholder: '必填，請填寫聯繫電話',
        amount: '合同金額',
        amountPlaceholder: '選填，請填寫合同金額',
        startTime: '開始時間',
        startTimePlaceholder: '必填，請填寫開始時間',
        endTime: '結束時間',
        endTimePlaceholder: '必填，請填寫結束時間',
        signingTime: '簽訂時間',
        signingTimePlaceholder: '必填，請填寫簽訂時間',
        contractFiles: '合同附件',
        addFile: '添加附件',
        fileIndex: '第{index}個',
        deleteFile: '刪除附件',
        cancel: '取消',
        save: '保存',
        saveSuccess: '合同保存成功',
        saveError: '合同保存失敗',
        fileTypeError: '僅支援PNG、PDF、JPG格式文件',
        uploadSuccess: '文件上傳成功',
        uploadError: '文件上傳失敗'
      },
      delete: {
        title: '請確認您的操作',
        confirmMessage: '確定刪除合同信息',
        cancel: '點錯了',
        confirm: '確認刪除',
        success: '合同刪除成功',
        error: '合同刪除失敗'
      }
    }
  }
}